export default __webpack_public_path__ + "static/media/download_voucher.b6a42ead.svg";